

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DeepCopy from '@/decorators/deep-copy';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired, validateType } from '../UI/Form/Validations';
import { GQL_WebstoreApiTokenCreate, GQL_ProductGroupUpdate } from '@/queries/global';
import { GQL_createWebstoreApiToken } from '@/queries/__generated__/createWebstoreApiToken';

@Component
export default class WebstoreApiTokenForm extends Vue {
  @Prop({ required: true, type: Object }) private data!: GQL_WebstoreApiTokenCreate | GQL_ProductGroupUpdate;
  @DeepCopy('data') private formData!: GQL_WebstoreApiTokenCreate | GQL_ProductGroupUpdate;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) private query!: any;

  private validForm = true;

  private rules: IRules = {
    webstoreApiToken: {
      expiryDate: [
       { validation: validateType('date'), message: i18n => i18n.t('GQL.Type.date') },
      ],
      description: [
        {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: this.t_attr('WebstoreApiToken', 'description') }),
        },
      ],
    },
  }

  private assignTokenValue(webstoreApiToken: { data: GQL_createWebstoreApiToken }) {
    this.$emit('mutation-done', webstoreApiToken.data.createWebstoreApiToken?.webstoreApiToken?.tokenValue);
  }

}
